module.exports = __webpack_public_path__ + "assets/3f2e585561da654ec291a013fb9b73e6.mp4";